import ModalCookieCompliance from './ModalCookieCompliance'

export default ModalCookieCompliance
// eslint-disable-next-line import/export
export * from './ModalCookieCompliance'
